module.exports = __webpack_public_path__ + "img/3_2025_04_15.3d601f4d.jpg";